import styled from 'styled-components'

import { Text } from '@interco/inter-ui/components/Text'
import { Timeline } from '@interco/inter-ui/components/Timeline'

export const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 1.5rem;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-bottom: 1rem;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`
export const TitleContainer = styled.div`
  padding-bottom: 1rem;
`

export const SubTitleContainer = styled.div`
  padding-top: 1rem;
`

export const PendingReasonContainer = styled.div`
  padding-top: 1rem;
`

export const ButtonContainer = styled.span`
  display: flex;
  padding: 1rem 0rem;

  & button {
    width: 100%;
  }
`

export const TrackingContainer = styled.div`
  margin-top: 2.5rem;
`

export const ProtocolContainer = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: var(--neutral-theme);
  cursor: pointer;
`

export const IconContainer = styled.div`
  display: flex;
  margin-left: 0.5rem;
`

export const TrackingIconContainer = styled.span<{
  width: number
  height: number
  color: string
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${({ color }) => color || 'black'};
  border-radius: 50%;
  padding: 2px;
  width: ${({ width }) => (width ? `${width}px` : '20px')};
  height: ${({ height }) => (height ? `${height}px` : '20px')};

  & span {
    color: ${({ color }) => color || 'black'};
  }
`

export const ServiceActionsContainer = styled.div`
  margin-top: 1rem;
  width: 100%;

  & button {
    width: 80%;
  }
`

export const TagContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem;
`

export const ServiceSubjectContainer = styled(Text)`
  text-overflow: ellipsis;
  text-wrap: nowrap;
  overflow: hidden;
`

export const TrackingItem = styled(Timeline.Item)`
  width: 100%;
  & > div {
    min-width: 0;
  }
`

export const TrackingItemTitle = styled(Text)`
  display: block;
  width: 100%;
  max-width: 100%;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
  text-overflow: unset !important;
  overflow: visible !important;
`
